import { useParams, Link } from 'react-router-dom';
import { ChainDetail } from '@/components/chains/ChainDetail';
import { ChainTimeline } from '@/components/chains/ChainTimeline';

export function ChainDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Chain not found</p>
        <Link to="/chains" className="text-brand-600 hover:text-brand-700 mt-2 inline-block">
          Back to chains
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <ChainDetail chainId={id} />
      <ChainTimeline chainId={id} />
    </div>
  );
}
